import 
    React
    , {
        useEffect
    } from 'react';

//import OwnIncomeProducing from "./OwnIncomeProducing1584x396";

/*
Dark background image = "linear-gradient(180deg, rgba(212, 222, 236, 0.3) 0%, rgba(217, 217, 217, 0) 100%)" />
Light background image = "linear-gradient(180deg, #000000 0%, #2C466B 100%)" />
*/

const RealsplitDeal = () => {
    console.log('RealsplitDeal()');

    useEffect(() => {
        //document.getElementsByTagName('body')[0].classList.add('');
        //document.getElementsByTagName('body')[0].classList.remove('search');
        document.getElementsByTagName('body')[0].className = '';
    }, null);

    return (
        <main>

            {/*
            <OwnIncomeProducing />
            */}
            <iframe
                //src = 'https://www.google.com' // Refused to display 'https://www.google.com/' in a frame because it set 'X-Frame-Options' to 'sameorigin'.
                src = 'https://realsplit.deal.tribexa.com/Community/Deal/Details/1450'
                style = {{ width: '100%', height: '100%' }}
                />

        </main>
    );
};

export default RealsplitDeal;
